import { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./CreateUser.css";
import SideMenu from "../../features/sideMenu/SideMenu";
import CustomButton from "../../ui/button/Button";
import { updateClient } from "../functions/Projects";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import { itemsProjects } from "../../constants/projects";
import "./EditClient.responsive.css";
import { formatEmpresa } from "../../utils/functionsFormat";

const EditClient = ({ API_URL, clients, setKey }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const showDialog = useConfirmDialog();

  // Estado inicial para el formulario
  const initialPayload = {
    razonSocial: "",
    alias: "",
    comentario: "",
    id: "",
  };

  const [payload, setPayload] = useState({
    ...initialPayload,
  });

  // Buscar el cliente correspondiente en el array de clients por el id
  useEffect(() => {
    const selectedClient = clients.find((client) => client.id === parseInt(id));

    if (selectedClient) {
      setPayload({
        razonSocial: selectedClient.razonSocial || "",
        alias: selectedClient.alias || "",
        comentario: selectedClient.comentario || null,
        id: selectedClient.id,
      });
    }
  }, [id, clients]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({
      ...prev,
      [name]: value || null,
    }));
  };

  //Normalizar nombre del cliente para el encabezado
  const displayName = useMemo(() => {
    const raw = payload.razonSocial || payload.alias || "Sin nombre";
    return formatEmpresa(raw);
  }, [payload.alias, payload.razonSocial]);

  const handleSave = async () => {
    if (!payload.razonSocial) {
      showDialog({
        html: "Por favor, ingresa el nombre del cliente.",
        icon: "warning",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return;
    }
    const formattedPayload = { ...payload };

    try {
      // Llamamos a la función updateClient
      await updateClient(API_URL, formattedPayload);

      // Forzamos la recarga de los datos en Clients
      setKey((prevKey) => prevKey + 1); // Esto forzará la recarga de los datos

      // Mostrar el mensaje de éxito usando el servicio de confirmDialog
      showDialog({
        html: "Cliente actualizado con éxito.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
        onConfirm: () => navigate(-1), // Redirigir a la página anterior
      });
    } catch (error) {
      console.error("Error al actualizar el cliente:", error);
      showDialog({
        html: `Error al actualizar el cliente:<br>${error.message}`,
        icon: "error",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
    }
  };

  return (
    <div className="ec-container" style={{ display: "flex", height: "100%" }}>
      <div className="ec-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <div className="createUser">
        <div className="form-container">
          <h2 className="form-title">Editar cliente: {displayName}</h2>
          <form>
            {/* Campo razonSocial */}
            <div className="form-row">
              <label className="form-label">Nombre:</label>
              <input
                className="form-input"
                type="text"
                name="razonSocial"
                value={payload.razonSocial || ""}
                onChange={handleChange}
                placeholder="Ingresa nombre"
              />
            </div>

            {/* Campo alias */}
            <div className="form-row">
              <label className="form-label">Nombre corto:</label>
              <input
                className="form-input"
                type="text"
                name="alias"
                value={payload.alias || ""}
                onChange={handleChange}
                placeholder="Ingresa nombre corto"
              />
            </div>

            <div className="button-container">
              <CustomButton
                text={"Guardar"}
                color={"#FFFFFF"}
                border={"none"}
                background={"#62C776"}
                fontStyle={"normal"}
                fontWeight={700}
                fontSize={"14px"}
                width={"75px"}
                height={"28px"}
                type={"button"}
                onClick={handleSave}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditClient;
